import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-adminlistados-extraescolares-crear',
  templateUrl: './adminlistados-extraescolares-crear.component.html',
  styleUrls: ['./adminlistados-extraescolares-crear.component.scss']
})
export class AdminlistadosExtraescolaresCrearComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/adminlistados-extraescolares-crear/adminlistados-extraescolares-crear.component.ts